import { useTranslation } from 'react-i18next';

const useInputOptions = () => {
  const { t } = useTranslation();
  const TOPIC_OF_INTEREST = {
    default: {
      label: t('digitalLeads.inputs.topicOfInterest.chooseTopic'),
      key: 'default',
      value: '',
    },
    general: {
      label: t('digitalLeads.inputs.topicOfInterest.general'),
      key: 'general',
      value: 'general',
    },
    testDrive: {
      label: t('digitalLeads.inputs.topicOfInterest.testDrive'),
      key: 'testDrive',
      value: 'testDrive',
    },
    pricing: {
      label: t('digitalLeads.inputs.topicOfInterest.pricing'),
      key: 'pricing',
      value: 'pricing',
    },
    specials: {
      label: t('digitalLeads.inputs.topicOfInterest.specials'),
      key: 'specials',
      value: 'specials',
    },
    other: {
      label: t('digitalLeads.inputs.topicOfInterest.other'),
      key: 'other',
      value: 'other',
    },
  };

  const TIER3_TOPIC_OF_INTEREST = {
    default: {
      label: t('digitalLeads.inputs.topicOfInterest.chooseTopic'),
      key: 'default',
      value: '',
    },
    general: {
      label: t('digitalLeads.inputs.topicOfInterest.general'),
      key: 'general',
      value: 'general',
    },
    testDrive: {
      label: t('digitalLeads.inputs.topicOfInterest.testDrive'),
      key: 'testDrive',
      value: 'testDrive',
    },
    pricing: {
      label: t('digitalLeads.inputs.topicOfInterest.pricing'),
      key: 'pricing',
      value: 'pricing',
    },
    specials: {
      label: t('digitalLeads.inputs.topicOfInterest.specials'),
      key: 'specials',
      value: 'specials',
    },
    service: {
      label: t('digitalLeads.inputs.topicOfInterest.service'),
      key: 'service',
      value: 'service',
    },
    parts: {
      label: t('digitalLeads.inputs.topicOfInterest.parts'),
      key: 'parts',
      value: 'parts',
    },
    requestCall: {
      label: t('digitalLeads.inputs.topicOfInterest.requestCall'),
      key: 'requestCall',
      value: 'requestCall',
    },
    other: {
      label: t('digitalLeads.inputs.topicOfInterest.other'),
      key: 'other',
      value: 'other',
    },
  };

  const ALL_TOPIC_OF_INTEREST = {
    default: {
      label: t('digitalLeads.inputs.topicOfInterest.chooseTopic'),
      key: 'default',
      value: '',
    },
    general: {
      label: t('digitalLeads.inputs.topicOfInterest.general'),
      key: 'general',
      value: 'general',
    },
    testDrive: {
      label: t('digitalLeads.inputs.topicOfInterest.testDrive'),
      key: 'testDrive',
      value: 'testDrive',
    },
    pricing: {
      label: t('digitalLeads.inputs.topicOfInterest.pricing'),
      key: 'pricing',
      value: 'pricing',
    },
    specials: {
      label: t('digitalLeads.inputs.topicOfInterest.specials'),
      key: 'specials',
      value: 'specials',
    },
    service: {
      label: t('digitalLeads.inputs.topicOfInterest.service'),
      key: 'service',
      value: 'service',
    },
    parts: {
      label: t('digitalLeads.inputs.topicOfInterest.parts'),
      key: 'parts',
      value: 'parts',
    },
    requestCall: {
      label: t('digitalLeads.inputs.topicOfInterest.requestCall'),
      key: 'requestCall',
      value: 'requestCall',
    },
    other: {
      label: t('digitalLeads.inputs.topicOfInterest.other'),
      key: 'other',
      value: 'other',
    },
  };

  const PREFERRED_CONTACT_METHOD = {
    email: {
      label: t('digitalLeads.inputs.email'),
      key: 'email',
      value: 'email',
      ariaLabel: 'email',
    },
    text: {
      label: t('digitalLeads.inputs.text'),
      key: 'text',
      value: 'text',
      ariaLabel: 'text',
    },
    phone: {
      label: t('digitalLeads.inputs.phone'),
      key: 'phone',
      value: 'phone',
      ariaLabel: 'phone',
    },
  };

  const CONTACT_TIME = {
    default: {
      label: t('digitalLeads.inputs.preferredContactMethod.selectTime'),
      subLabel: '',
      key: 'default',
      value: 'NO_PREFERENCE',
      ariaLabel: 'default',
    },
    morning: {
      label: t('digitalLeads.inputs.preferredContactMethod.morning'),
      subLabel: '(9am - 12pm)',
      key: 'morning',
      value: 'MORNING',
      ariaLabel: 'morning',
    },
    afternoon: {
      label: t('digitalLeads.inputs.preferredContactMethod.afternoon'),
      subLabel: '(12pm - 5pm)',
      key: 'afternoon',
      value: 'AFTERNOON',
      ariaLabel: 'afternoon',
    },
    evening: {
      label: t('digitalLeads.inputs.preferredContactMethod.evening'),
      subLabel: '(5pm - 9pm)',
      key: 'evening',
      value: 'EVENING',
      ariaLabel: 'evening',
    },
  };

  const PURCHASE_TIME_FRAME = {
    default: {
      label: '',
      subLabel: '',
      key: 'default',
      value: '',
      ariaLabel: 'default',
    },
    now: {
      label: t('digitalLeads.inputs.timeOfPurchase.now'),
      subLabel: '',
      key: 'now',
      value: 'Now',
      ariaLabel: 'now',
    },
    onemonth: {
      label: t('digitalLeads.inputs.timeOfPurchase.withinOneMonth'),
      subLabel: '',
      key: 'onemonth',
      value: 'Within 1 month',
      ariaLabel: 'onemonth',
    },
    threemonths: {
      label: t('digitalLeads.inputs.timeOfPurchase.withinThreeMonths'),
      subLabel: '',
      key: 'threemonths',
      value: 'Within 3 months',
      ariaLabel: 'threemonths',
    },
    sixmonths: {
      label: t('digitalLeads.inputs.timeOfPurchase.withinSixMonths'),
      subLabel: '',
      key: 'sixmonths',
      value: 'Within 6 months',
      ariaLabel: 'sixmonths',
    },
    twelvemonths: {
      label: t('digitalLeads.inputs.timeOfPurchase.withinOneYear'),
      subLabel: '',
      key: 'twelvemonths',
      value: 'Within 12 months',
      ariaLabel: 'twelvemonths',
    },
    twelvemonthsover: {
      label: t('digitalLeads.inputs.timeOfPurchase.overOneYear'),
      subLabel: '',
      key: 'twelvemonthsover',
      value: 'Over 12 months',
      ariaLabel: 'twelvemonthsover',
    },
    unsure: {
      label: t('digitalLeads.inputs.timeOfPurchase.unsure'),
      subLabel: '',
      key: 'unsure',
      value: 'Unsure',
      ariaLabel: 'unsure',
    },
  };

  const PREFERRED_DEALER = {
    eventTOR: {
      default: {
        label: '',
        subLabel: '',
        key: 'default',
        value: '',
        ariaLabel: 'default',
      },
      dealer1: {
        label: 'Audi Brampton',
        key: 'dealer1',
        value: '93352',
        ariaLabel: 'Audi Brampton',
      },
      dealer2: {
        label: 'Audi Downtown Toronto',
        key: 'dealer2',
        value: '93168',
        ariaLabel: 'Audi Downtown Toronto',
      },
      dealer3: {
        label: 'Audi Durham',
        key: 'dealer3',
        value: '93078',
        ariaLabel: 'Audi Durham',
      },
      dealer4: {
        label: 'Audi Midtown Toronto',
        key: 'dealer4',
        value: '93032',
        ariaLabel: 'Audi Midtown Toronto',
      },
      dealer6: {
        label: 'Audi Mississauga',
        key: 'dealer6',
        value: '93362',
        ariaLabel: 'Audi Mississauga',
      },
      dealer5: {
        label: 'Audi Oakville',
        key: 'dealer5',
        value: '93201',
        ariaLabel: 'Audi Oakville',
      },
      dealer7: {
        label: 'Audi Queensway',
        key: 'dealer7',
        value: '93205',
        ariaLabel: 'Audi Queensway',
      },
      dealer8: {
        label: 'Audi Thornhill',
        key: 'dealer8',
        value: '93011',
        ariaLabel: 'Audi Thornhill',
      },
      dealer9: {
        label: 'Audi Uptown',
        key: 'dealer9',
        value: '93023',
        ariaLabel: 'Audi Uptown',
      },
      dealer10: {
        label: 'HJ Pfaff Motors',
        key: 'dealer10',
        value: '93015',
        ariaLabel: 'HJ Pfaff Motors',
      },
      dealer11: {
        label: 'Pfaff Audi',
        key: 'dealer11',
        value: '93017',
        ariaLabel: 'Pfaff Audi',
      },
    },
    eventMTL: {
      default: {
        label: '',
        subLabel: '',
        key: 'default',
        value: '',
        ariaLabel: 'default',
      },
      dealer4: {
        label: 'Audi Anjou',
        key: 'dealer4',
        value: '94831',
        ariaLabel: 'Audi Anjou',
      },
      dealer2: {
        label: 'Audi Blainville',
        key: 'dealer2',
        value: '94757',
        ariaLabel: 'Audi Blainville',
      },
      dealer1: {
        label: 'Audi Lauzon',
        key: 'dealer1',
        value: '94753',
        ariaLabel: 'Audi Lauzon',
      },
      dealer5: {
        label: 'Audi Popular',
        key: 'dealer5',
        value: '94708',
        ariaLabel: 'Audi Popular',
      },
      dealer6: {
        label: 'Audi St. Bruno',
        key: 'dealer6',
        value: '94801',
        ariaLabel: 'Audi St. Bruno',
      },
      dealer8: {
        label: 'Audi St. Laurent',
        key: 'dealer8',
        value: '94827',
        ariaLabel: 'Audi St. Laurent',
      },
      dealer3: {
        label: 'Audi West Island',
        key: 'dealer3',
        value: '94817',
        ariaLabel: 'Audi West Island',
      },
      dealer7: {
        label: 'Park Avenue Audi',
        key: 'dealer7',
        value: '94826',
        ariaLabel: 'Park Avenue Audi',
      },
    },
    eventVAN: {
      default: {
        label: '',
        subLabel: '',
        key: 'default',
        value: '',
        ariaLabel: 'default',
      },
      dealer2: {
        label: 'Audi Boundary',
        key: 'dealer2',
        value: '91450',
        ariaLabel: 'Audi Boundary',
      },
      dealer3: {
        label: 'Audi Downtown Vancouver',
        key: 'dealer3',
        value: '91452',
        ariaLabel: 'Audi Downtown Vancouver',
      },
      dealer4: {
        label: 'Audi Langley',
        key: 'dealer4',
        value: '91454',
        ariaLabel: 'Audi Langley',
      },
      dealer1: {
        label: 'Audi Richmond',
        key: 'dealer1',
        value: '91445',
        ariaLabel: 'Audi Richmond',
      },
      dealer5: {
        label: 'Capilano Audi',
        key: 'dealer5',
        value: '91458',
        ariaLabel: 'Capilano Audi',
      },
    },
    eventEDM: {
      default: {
        label: '',
        subLabel: '',
        key: 'default',
        value: '',
        ariaLabel: 'default',
      },
      dealer1: {
        label: 'Audi Edmonton North',
        key: 'dealer1',
        value: '91570',
        ariaLabel: 'Audi Edmonton North',
      },
      dealer2: {
        label: 'Southgate Audi',
        key: 'dealer2',
        value: '91588',
        ariaLabel: 'Southgate Audi',
      },
    },
  };

  return {
    TOPIC_OF_INTEREST,
    PREFERRED_CONTACT_METHOD,
    CONTACT_TIME,
    PURCHASE_TIME_FRAME,
    PREFERRED_DEALER,
    TIER3_TOPIC_OF_INTEREST,
    ALL_TOPIC_OF_INTEREST,
  };
};

export default useInputOptions;
